import React from 'react';

const vowels = ['a', 'e', 'i', 'o', 'u'];
const consonants = 'bcdfghjklmnpqrstvwxyz';
const irregularVerbs = [
    ['arise', 'arose', 'arisen'],
    ['babysit', 'babysat', 'babysat'],
    ['beat', 'beat', 'beaten'],
    ['become', 'became', 'become'],
    ['bend', 'bent', 'bent'],
    ['begin', 'began', 'begun'],
    ['bet', 'bet', 'bet'],
    ['bind', 'bound', 'bound'],
    ['bite', 'bit', 'bitten'],
    ['bleed', 'bled', 'bled'],
    ['blow', 'blew', 'blown'],
    ['break', 'broke', 'broken'],
    ['breed', 'bred', 'bred'],
    ['bring', 'brought', 'brought'],
    ['broadcast', 'broadcast', 'broadcast'],
    ['build', 'built', 'built'],
    ['buy', 'bought', 'bought'],
    ['catch', 'caught', 'caught'],
    ['choose', 'chose', 'chosen'],
    ['come', 'came', 'come'],
    ['cost', 'cost', 'cost'],
    ['cut', 'cut', 'cut'],
    ['deal', 'dealt', 'dealt'],
    ['dig', 'dug', 'dug'],
    ['do', 'did', 'done'],
    ['draw', 'drew', 'drawn'],
    ['drink', 'drank', 'drunk'],
    ['drive', 'drove', 'driven'],
    ['eat', 'ate', 'eaten'],
    ['fall', 'fell', 'fallen'],
    ['feed', 'fed', 'fed'],
    ['feel', 'felt', 'felt'],
    ['fight', 'fought', 'fought'],
    ['find', 'found', 'found'],
    ['fly', 'flew', 'flown'],
    ['forbid', 'forbade', 'forbidden'],
    ['forget', 'forgot', 'forgotten'],
    ['forgive', 'forgave', 'forgiven'],
    ['freeze', 'froze', 'frozen'],
    ['get', 'got', 'got'],
    ['give', 'gave', 'given'],
    ['go', 'went', 'gone'],
    ['grow', 'grew', 'grown'],
    ['have', 'had', 'had'],
    ['hear', 'heard', 'heard'],
    ['hide', 'hid', 'hidden'],
    ['hit', 'hit', 'hit'],
    ['hold', 'held', 'held'],
    ['hurt', 'hurt', 'hurt'],
    ['keep', 'kept', 'kept'],
    ['know', 'knew', 'known'],
    ['lay', 'laid', 'laid'],
    ['lead', 'led', 'led'],
    ['leave', 'left', 'left'],
    ['lend', 'lent', 'lent'],
    ['let', 'let', 'let'],
    ['light', 'lit', 'lit'],
    ['lose', 'lost', 'lost'],
    ['make', 'made', 'made'],
    ['mean', 'meant', 'meant'],
    ['meet', 'met', 'met'],
    ['pay', 'paid', 'paid'],
    ['put', 'put', 'put'],
    ['quit', 'quit', 'quit'],
    ['read', 'read', 'read'],
    ['ride', 'rode', 'ridden'],
    ['ring', 'rang', 'rung'],
    ['rise', 'rose', 'risen'],
    ['run', 'ran', 'run'],
    ['say', 'said', 'said'],
    ['see', 'saw', 'seen'],
    ['sell', 'sold', 'sold'],
    ['send', 'sent', 'sent'],
    ['set', 'set', 'set'],
    ['shake', 'shook', 'shaken'],
    ['shine', 'shone', 'shone'],
    ['shoot', 'shot', 'shot'],
    ['show', 'showed', 'shown'],
    ['shut', 'shut', 'shut'],
    ['sing', 'sang', 'sung'],
    ['sink', 'sank', 'sunk'],
    ['sit', 'sat', 'sat'],
    ['sleep', 'slept', 'slept'],
    ['slide', 'slid', 'slid'],
    ['speak', 'spoke', 'spoken'],
    ['speed', 'sped', 'sped'],
    ['spend', 'spent', 'spent'],
    ['spin', 'spun', 'spun'],
    ['spread', 'spread', 'spread'],
    ['stand', 'stood', 'stood'],
    ['steal', 'stole', 'stolen'],
    ['stick', 'stuck', 'stuck'],
    ['sting', 'stung', 'stung'],
    ['strike', 'struck', 'struck'],
    ['swear', 'swore', 'sworn'],
    ['sweep', 'swept', 'swept'],
    ['swim', 'swam', 'swum'],
    ['swing', 'swung', 'swung'],
    ['take', 'took', 'taken'],
    ['teach', 'taught', 'taught'],
    ['tear', 'tore', 'torn'],
    ['tell', 'told', 'told'],
    ['think', 'thought', 'thought'],
    ['throw', 'threw', 'thrown'],
    ['understand', 'understood', 'understood'],
    ['wake', 'woke', 'woken'],
    ['wear', 'wore', 'worn'],
    ['win', 'won', 'won'],
    ['withdraw', 'withdrew', 'withdrawn'],
    ['write', 'wrote', 'written']
];

export default class Sentence {
    private keywords: any;

    constructor(keywords: any) {
        this.keywords = keywords;
    }

    byTense(tense: number) {
        let subject = this.keywords.subject,
            verb = this.keywords.verb.trim().toLowerCase(),
            object = this.keywords.object,
            preps = this.keywords.preps ? this.keywords.preps : {};

        if ([1, 3, 5, 7, 9, 11].indexOf(tense) > -1) {
            return (
                <span>{subject} {preps.subject} {this.auxiliary(subject, tense)} {this.continuous(verb)}
                    &nbsp;{object} {preps.object}</span>
            );
        } else if ([2, 6, 10].indexOf(tense) > -1) {
            return (
                <span>{subject} {preps.subject} {this.auxiliary(subject, tense)} {this.past(verb, 1)}
                    &nbsp;{object} {preps.object}</span>
            );
        } else if (tense === 4) {
            return (
                <span>{subject} {preps.subject} {this.past(verb, 0)} {object} {preps.object}</span>
            );
        } else if (tense === 8) {
            return (
                <span>{subject} {preps.subject} {this.auxiliary(subject, tense)} {verb}&nbsp;
                    {object} {preps.object}</span>
            );
        } else {
            return <span>{subject} {preps.subject} {verb} {this.isTPS(subject) ? 's' : ''} {object}</span>;
        }
    }

    isTPS(subject: string) {
        // Third person singular?
        return ['i', 'we', 'they', 'you'].indexOf(subject) === -1;
    }

    past(verb: string, type: any) {
        if (!verb.length) {
            return '';
        }
        let irregular = irregularVerbs.filter(v => v[0] === verb);
        if (irregular.length) {
            return type === 0 ? irregular[0][1] : irregular[0][2];
        } else {
            let n = verb.length;
            if (verb.charAt(n - 1) === 'e') {
                return verb + 'd';

            } else if (verb.charAt(n - 1) === 'y'
                && consonants.indexOf(verb.charAt(n - 2)) > -1) {

                return verb.slice(0, -1) + 'ied';

            } else if (vowels.indexOf(verb.charAt(n - 2)) > -1
                && consonants.indexOf(verb.charAt(n - 1)) > -1
                && this.countVowels(verb) === 1) {

                return verb + verb.charAt(n - 1) + 'ed';
            }
        }
        return verb + 'ed';
    }

    countVowels(word: string) {
        return vowels.filter(el => word.indexOf(el) > -1).length;
    }

    auxiliary(subject: string, tense: any) {
        let noun = typeof subject === 'string' ? subject.toLowerCase() : subject;
        return tense === 1 ?
            noun === 'i' ? 'am'
                : ['we', 'they', 'you'].indexOf(noun) > -1 ? 'are'
                    : 'is'
            : tense === 2 ?
                ['i', 'we', 'they', 'you'].indexOf(noun) > -1 ? 'have'
                    : 'has'
                : tense === 3 ?
                    ['i', 'we', 'they', 'you'].indexOf(noun) > -1 ? 'have been'
                        : 'has been'

                    : tense === 5 ?
                        ['we', 'they', 'you'].indexOf(noun) > -1 ? 'are'
                            : 'was'
                        : tense === 6 ? 'had'
                            : tense === 7 ? 'had been'

                                : tense === 8 ? 'will'
                                    : tense === 9 ? 'will be'
                                        : tense === 10 ? 'will have'
                                            : tense === 11 ? 'will have been'
                                                : '';
    }

    continuous(verb: string) {
        if (!verb.length) {
            return '';
        }
        let n = verb.length;
        if (verb.slice(0, n - 2) === 'ie') {
            return verb.slice(0, -2) + 'ying';

        } else if (verb.charAt(n - 1) === 'e') {
            return verb.slice(0, -1) + 'ing';

        } else if ('wxy'.indexOf(verb.charAt(n - 1)) === -1) {

            if (vowels.indexOf(verb.charAt(n - 2)) > -1
                && consonants.indexOf(verb.charAt(n - 1)) > -1
                && this.countVowels(verb) === 1) {

                return verb + verb.charAt(n - 1) + 'ing';
            }
        }
        return verb + 'ing';
    }
}


// WEBPACK FOOTER //
// ./src/components/activityFeed/Sentence.tsx